export const enum HotjarEvent {
  FindingAccommodationSurveySE = 'FindingAccommodationSurveySE',
  FindingAccommodationSurveyNO = 'FindingAccommodationSurveyNO',
  FindingAccommodationSurveyDK = 'FindingAccommodationSurveyDK',

  FindingFlightsSurveySE = 'FindingFlightsSurveySE',
  FindingFlightsSurveyNO = 'FindingFlightsSurveyNO',
  FindingFlightsSurveyDK = 'FindingFlightsSurveyDK',
}
